import environment from "src/utils/environment";

const { nativeTheme } = window.require("@electron/remote");

export default function getIsDarkMode() {
  if (environment.isBrowser) {
    return window.matchMedia("(prefers-color-scheme: dark)").matches;
  }
  return nativeTheme.shouldUseDarkColors;
}
